module.exports = __webpack_public_path__ + "2a4202c79a6ead4dfeb03043ba1106bf.png";